import Vue from 'vue'
import Vuex from 'vuex'

import admin from './admin.js'
import promo from './promo.js'
import equipment from './equipment.js'
import user from './user.js'
import alert from './alert.js'
import address from './address.js'
import payment from './payment.js'
import news from './news.js'
import favorites from './favorites.js'
import shipping from './shipping.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    admin, equipment, user, promo, alert, address, payment, news, favorites, shipping
  }
})
